import { render, staticRenderFns } from "./LeitoHistorico.vue?vue&type=template&id=1470517d&"
import script from "./LeitoHistorico.vue?vue&type=script&lang=js&"
export * from "./LeitoHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports